import { Filters } from 'features/Filters/types/Filters';

export const defaultFilters: Filters = {
  spaceIds: [],
  mediaOwnerNames: [],
  environments: [],
  formatSizeNames: [],
  statuses: [],
};
